import { render, staticRenderFns } from "./ereceiptFormPageForIframe.vue?vue&type=template&id=57a56c35&"
import script from "./ereceiptFormPageForIframe.vue?vue&type=script&lang=js&"
export * from "./ereceiptFormPageForIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports